export const generalButtonStyles = {
  type: 'button',
  fontSize: '18px',
  fontWeight: '600',
  borderRadius: '4px',
  p: ['1.1rem 3rem', '1.3rem 4rem'],
  borderRadius: '5px',
  width: ['100%', 'auto'],
};
